var _circle, _rect, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2526_53443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 51,
    width: 140,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 51,
    width: 140,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2526_53443)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.5 97.6666V86C142.5 81.1389 140.799 77.0069 137.396 73.6041C133.993 70.2014 129.861 68.5 125 68.5C120.139 68.5 116.007 70.2014 112.604 73.6041C109.201 77.0069 107.5 81.1389 107.5 86V97.6666H142.5ZM126.458 179.333H90C86.7916 179.333 84.0451 178.191 81.7604 175.906C79.4757 173.622 78.3333 170.875 78.3333 167.667V109.333C78.3333 106.125 79.4757 103.378 81.7604 101.094C84.0451 98.809 86.7916 97.6666 90 97.6666H95.8333V86C95.8333 77.9305 98.6771 71.0521 104.365 65.3646C110.052 59.6771 116.931 56.8333 125 56.8333C133.069 56.8333 139.948 59.6771 145.635 65.3646C151.323 71.0521 154.167 77.9305 154.167 86V97.6666H160C163.208 97.6666 165.955 98.809 168.24 101.094C170.524 103.378 171.667 106.125 171.667 109.333V116.917C169.722 116.236 167.778 115.774 165.833 115.531C163.889 115.288 161.944 115.167 160 115.167C148.625 115.167 138.976 119.128 131.052 127.052C123.128 134.976 119.167 144.625 119.167 156C119.167 160.181 119.823 164.24 121.135 168.177C122.448 172.115 124.222 175.833 126.458 179.333Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.333 173.5H160V156H177.5V144.333H160V126.833H148.333V144.333H130.833V156H148.333V173.5Z",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLock);
export default __webpack_public_path__ + "static/media/addLock.3a1d0d25863b5091d8bd11d939012d1c.svg";
export { ForwardRef as ReactComponent };